import { get } from 'services/request';
import { IPanelCard } from 'types/content';
import { BaseModel, IModelOptions } from './BaseModel';

export default class PanelCardModel extends BaseModel {
  constructor(options: IModelOptions & { panelId: number }) {
    super(options);
    this.loadItemEdit(options.panelId);
  }

  async loadItemData(id: number) {
    const vocCards = await get<IPanelCard[]>(`panels/${id}/card`);
    return { cardData: vocCards[0] };
  }
}
